// extracted by mini-css-extract-plugin
export var basic = "style-module--basic--99gHe";
export var imglyTypoButton = "style-module--imgly--typo-button--omt7g";
export var imglyTypoButtonSmall = "style-module--imgly--typo-button-small--hi6+L";
export var imglyTypoH1 = "style-module--imgly--typo-h1--T9+Rc";
export var imglyTypoH2 = "style-module--imgly--typo-h2--L+EJG";
export var imglyTypoH2BodyText = "style-module--imgly--typo-h2-body-text--5dWbD";
export var imglyTypoH3 = "style-module--imgly--typo-h3--GfKfK";
export var imglyTypoH3BodyText = "style-module--imgly--typo-h3-body-text--FgLJz";
export var imglyTypoH4 = "style-module--imgly--typo-h4--ulM4w";
export var imglyTypoH5 = "style-module--imgly--typo-h5--1mcxS";
export var imglyTypoH5IsSmall = "style-module--imgly--typo-h5-is-small--vVfV5";
export var imglyTypoIcon = "style-module--imgly--typo-icon--gcQEB";
export var imglyTypoLink = "style-module--imgly--typo-link--pdN7P";
export var imglyTypoOverline = "style-module--imgly--typo-overline--lHfAE";
export var imglyTypoOverlineSmall = "style-module--imgly--typo-overline-small--yStGH";
export var imglyTypoParagraph = "style-module--imgly--typo-paragraph--4txI1";
export var imglyTypoParagraphBig = "style-module--imgly--typo-paragraph-big--FdxBZ";
export var imglyTypoParagraphBodyText = "style-module--imgly--typo-paragraph-body-text--lr+w3";
export var imglyTypoParagraphSmall = "style-module--imgly--typo-paragraph-small--tSDQu";
export var imglyTypoSubline = "style-module--imgly--typo-subline--4iE7w";
export var imglyTypoSublineBodyText = "style-module--imgly--typo-subline-body-text--Z5j8c";
export var logo = "style-module--logo--tWxPw";
export var logoContainer = "style-module--logoContainer--QAO4p";
export var naviLabelIsLarge = "style-module--navi-label-is-large--9HSzm";
export var naviLabelIsSmall = "style-module--navi-label-is-small--O+Sph";
export var root = "style-module--root--yqufj";
export var text = "style-module--text--CI+so";
export var wrapper = "style-module--wrapper--OCB6J";